// extracted by mini-css-extract-plugin
export var readonly = "_g6-1";
export var star = "_g6-0";